<form [formGroup]="formGroup()">
  <div class="flex flex-col mb-7">
    <p-card header="Powiadomienia e-mail" styleClass="mb-6" tabindex="0">
      <div class="flex flex-col gap-5">
        <div>
          <p-checkbox
            [binary]="true"
            [formControl]="formGroup().controls.newDocument"
            id="newDocument"
            inputId="newDocument"
            styleClass="customCheckbox"
          />
          <label class="ml-2" for="newDocument"
            >Powiadomienie o nowym dokumencie</label
          >
        </div>
        <div>
          <p-checkbox
            [binary]="true"
            [formControl]="formGroup().controls.documentPickupDeadline"
            id="documentPickupDeadline"
            inputId="documentPickupDeadline"
            styleClass="customCheckbox"
          />
          <label class="ml-2" for="documentPickupDeadline"
            >Powiadomienie o upływającym terminie odebrania dokumentu</label
          >
        </div>
        <div>
          <p-checkbox
            [binary]="true"
            [formControl]="formGroup().controls.documentPickupOverdue"
            id="documentPickupOverdue"
            inputId="documentPickupOverdue"
            styleClass="customCheckbox"
          />
          <label class="ml-2" for="documentPickupOverdue"
            >Powiadomienie o przekroczonym terminie odebrania dokumentu</label
          >
        </div>
        <div>
          <p-checkbox
            [binary]="true"
            [formControl]="formGroup().controls.applicationStatusChange"
            id="applicationStatusChange"
            inputId="applicationStatusChange"
            styleClass="customCheckbox"
          />
          <label class="ml-2" for="applicationStatusChange"
            >Powiadomienie o zmianie statusu wniosku</label
          >
        </div>
      </div>
    </p-card>
    <p-card header="Zgody" styleClass="mb-6" tabindex="0">
      <div class="flex flex-col gap-5">
        <div>
          <p-checkbox
            [binary]="true"
            [formControl]="formGroup().controls.electronicNotificationsConsent"
            id="electronicNotificationsConsent"
            inputId="electronicNotificationsConsent"
            styleClass="customCheckbox"
          />
          <label class="ml-2" for="electronicNotificationsConsent"
            >Zgadzam się na otrzymywanie powiadomień z Urzędu za pomocą środków
            komunikacji elektronicznej</label
          >
        </div>
        <div>
          <p-checkbox
            [binary]="true"
            [formControl]="
              formGroup().controls.electronicNotificationsAnnouncementsConsent
            "
            id="electronicNotificationsAnnouncementsConsent"
            inputId="electronicNotificationsAnnouncementsConsent"
            styleClass="customCheckbox"
          />
          <label class="ml-2" for="electronicNotificationsAnnouncementsConsent"
            >Zgadzam się na otrzymywanie komunikatów za pomocą środków
            komunikacji elektronicznej</label
          >
        </div>
        <div>
          <p-checkbox
            [binary]="true"
            [formControl]="formGroup().controls.automaticDataUpdateConsent"
            id="automaticDataUpdateConsent"
            inputId="automaticDataUpdateConsent"
            styleClass="customCheckbox"
          />
          <label class="ml-2" for="automaticDataUpdateConsent"
          >Zgadzam się na automatyczne zapisywanie danych wprowadzonych we wnioskach do zakładki „Moje dane”</label
          >
        </div>
      </div>
    </p-card>
    <p-card header="Dezaktywacja konta" tabindex="0">
      <p>
        Dezaktywacja konta spowoduje automatyczne wylogowanie użytkownika oraz
        zablokuje możliwość ponownego logowania. Po dezaktywacji dostęp do
        dokumentów i danych w systemie nie będzie możliwy. Odzyskanie dostępu
        wymaga ponownej rejestracji użytkownika.
      </p>
      <div class="flex gap-2 mt-5">
        <p-button
          (click)="openDeactivateDialog()"
          label="Dezaktywuj konto"
          styleClass="customInfoButton outlined"
        ></p-button>
      </div>
    </p-card>
  </div>
</form>

<div class="flex justify-end mt-6 gap-2">
  <p-button
    (click)="goToHomepage()"
    label="Wstecz"
    styleClass="customInfoButton outlined"
  />
  <p-button
    (click)="save()"
    [disabled]="formGroup().pristine"
    label="Zapisz"
    styleClass="customInfoButton"
  />
</div>
